import { Box, Grid, GridItem, Img, Text } from '@chakra-ui/react';
import { useEffect, useState, useContext, useMemo } from 'react';
import { getImages } from 'utils/game/gameService';
import { motion } from 'framer-motion';
import { ScoreContext } from '../GamePreview';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducers';
import { useParams } from 'react-router-dom';

const Completion: React.FC<{
  formData: any;
  imageSrc: any;
  selectedBadge?: any;
  compliData?: any;
  setCompliData?: any;
  CompKeyCount?: any;
  preview?: any;
  questState: any;
  setType: any;
  setData: any;
  setQuestState: any;
  type: any;
  getFeedbackData: any;
  setCurrentScreenId?: any;
  currentScreenId: any;
  getData?: any;
  gameInfo: any;
  data?: any;
  setFeedbackNavigateNext: any;
  screen?: any;
  profile: any;
  completionScreenQuestOptions: any;
  questOptions: any;
  currentQuestNo: any;
  preloadedAssets: any;
  questWiseMaxTotal: any;
  gameInfoTotalScore: any;
  setProfile: any;
  getPrevLogDatas: any;
  demoBlocks: any;
  setOptions: any;
  profileData: any;
  feedbackList: any;
  setFeedbackList: any;
  setReplayIsOpen: any;
  setReplayState: any;
}> = ({
  currentScreenId,
  setCurrentScreenId,
  preview,
  selectedBadge,
  formData,
  imageSrc,
  gameInfo,
  setType,
  setData,
  type,
  questState,
  setQuestState,
  compliData,
  setCompliData,
  setFeedbackNavigateNext,
  CompKeyCount,
  profile,
  getData,
  data,
  screen,
  getFeedbackData,
  completionScreenQuestOptions,
  questOptions,
  currentQuestNo,
  preloadedAssets,
  questWiseMaxTotal,
  gameInfoTotalScore,
  setProfile,
  getPrevLogDatas,
  demoBlocks,
  setOptions,
  profileData,
  setFeedbackList,
  feedbackList,
  setReplayState,
  setReplayIsOpen,
}) => {
  const previewStateData = useSelector((state: RootState) =>
    formData?.gameId && state.preview ? state.preview[formData?.gameId] : null,
  );

  const [showComplete, setShowComplete] = useState(false);
  const [curretQuestOptions, setCurrentQuestOptions] = useState(
    completionScreenQuestOptions?.find(
      (quest: any) => quest?.gameQuestNo == profile?.currentQuest,
    ),
  );

  const finalProfileScore =
    Object.entries(profile?.playerGrandTotal?.questScores).length > 0
      ? profile?.playerGrandTotal?.questScores[
          parseInt(profile.currentQuest)
        ] !== null
        ? profile?.playerGrandTotal?.questScores[parseInt(profile.currentQuest)]
        : curretQuestOptions?.gameMinScore
        ? curretQuestOptions?.gameMinScore
        : 0
      : curretQuestOptions?.gameMinScore
      ? curretQuestOptions?.gameMinScore
      : 0;
  // let finalProfileScore = 0;
  const [geFinalscorequest, SetFinalscore] = useState(finalProfileScore);
  const [questScores, setQuestScores] = useState(questWiseMaxTotal);
  const [quetCompletionMessage, setQuestCompletionMessage] =
    useState<string>('');
  const [testScoreTotal, setTestScoreTotal] = useState<number>(0);

  const [QuestTitleLanguage, setQuestTitleLanguage] = useState(null);
  const { id } = useParams();
  const Gameid = id ? id : null;

  const findQuestCompletionMessage = () => {
    const questNoParsed = parseInt(currentQuestNo);

    const playerCurrentQuestGrandTotal =
      profile.playerGrandTotal.questScores[questNoParsed] ?? 0;
    let completionScreenMessage = '';

    // ✅ ## Use filter to get quest by gameQuestNo
    const currentQuesTGameData = completionScreenQuestOptions.filter(
      (quest: any) => quest.gameQuestNo === questNoParsed,
    )[0];

    // Ensure `gameIsSetCongratsSingleMessage` is evaluated as a boolean
    const isSingleMessage =
      currentQuesTGameData?.gameIsSetCongratsSingleMessage === 'true';
    const isScoreWiseMessage =
      currentQuesTGameData?.gameIsSetCongratsScoreWiseMessage === 'true';

    if (isSingleMessage) {
      const questContentFiltered = profileData?.Audiogetlanguage.filter(
        (key: any) => key?.textId === parseInt(currentQuestNo),
      );

      const congratsMsgFiltered = questContentFiltered?.filter(
        (key: any) => key?.fieldName === 'gameCompletedCongratsMessage',
      );

      completionScreenMessage = congratsMsgFiltered?.[0]?.content
        ? congratsMsgFiltered[0]?.content
        : currentQuesTGameData?.gameCompletedCongratsMessage;
    } else if (isScoreWiseMessage) {
      if (
        playerCurrentQuestGrandTotal >
        currentQuesTGameData?.gameDistinctionScore
      ) {
        if (currentQuesTGameData?.gameIsSetDistinctionScore === 'true') {
          completionScreenMessage =
            currentQuesTGameData?.gameAboveDistinctionScoreCongratsMessage;
        } else {
          if (
            playerCurrentQuestGrandTotal > currentQuesTGameData?.gameMinScore
          ) {
            completionScreenMessage =
              currentQuesTGameData?.gameaboveMinimumScoreCongratsMessage;
          }
        }
      } else if (
        playerCurrentQuestGrandTotal ===
        currentQuesTGameData?.gameDistinctionScore
      ) {
        if (currentQuesTGameData?.gameIsSetDistinctionScore === 'true') {
          completionScreenMessage =
            currentQuesTGameData?.gameAboveDistinctionScoreCongratsMessage;
        } else {
          if (
            playerCurrentQuestGrandTotal > currentQuesTGameData?.gameMinScore
          ) {
            completionScreenMessage =
              currentQuesTGameData?.gameaboveMinimumScoreCongratsMessage;
          }
        }
      } else if (
        playerCurrentQuestGrandTotal > currentQuesTGameData?.gameMinScore
      ) {
        completionScreenMessage =
          currentQuesTGameData?.gameaboveMinimumScoreCongratsMessage;
      } else if (
        playerCurrentQuestGrandTotal === currentQuesTGameData?.gameMinScore
      ) {
        completionScreenMessage =
          currentQuesTGameData?.gameaboveMinimumScoreCongratsMessage;
      } else if (
        playerCurrentQuestGrandTotal < currentQuesTGameData?.gameMinScore
      ) {
        if (currentQuesTGameData?.gameIsSetMinPassScore === 'true') {
          completionScreenMessage =
            currentQuesTGameData?.gameMinimumScoreCongratsMessage;
        } else {
          if (
            playerCurrentQuestGrandTotal <
            currentQuesTGameData?.gameDistinctionScore
          )
            completionScreenMessage =
              currentQuesTGameData?.gameaboveMinimumScoreCongratsMessage;
        }
      }
    } else if (
      !isSingleMessage &&
      !isScoreWiseMessage &&
      !currentQuesTGameData?.gameIsSetDistinctionScore &&
      !currentQuesTGameData?.gameIsSetMinPassScore
    ) {
      const questContentFiltered = profileData?.Audiogetlanguage.filter(
        (key: any) => key?.textId === parseInt(currentQuestNo),
      );

      const congratsMsgFiltered = questContentFiltered?.filter(
        (key: any) => key?.fieldName === 'gameCompletedCongratsMessage',
      );

      completionScreenMessage = congratsMsgFiltered?.[0]?.content
        ? congratsMsgFiltered[0]?.content
        : currentQuesTGameData?.gameCompletedCongratsMessage;
    } else {
      const questContentFiltered = profileData?.Audiogetlanguage.filter(
        (key: any) => key?.textId === parseInt(currentQuestNo),
      );
      const congratsMsgFiltered = questContentFiltered?.filter(
        (key: any) => key?.fieldName === 'gameCompletedCongratsMessage',
      );

      completionScreenMessage = congratsMsgFiltered?.[0]?.content
        ? congratsMsgFiltered[0]?.content
        : currentQuesTGameData?.gameCompletedCongratsMessage;
    }

    setQuestCompletionMessage(completionScreenMessage);
  };

  const PromptForNoCompletionScreen = () => {
    if (curretQuestOptions?.gameCompletedCongratsMessage === null) {
      setReplayState('Nocompletion');
      setReplayIsOpen(true);
      return;
    }
  };
  useEffect(() => {
    setShowComplete(true);
    setTimeout(() => {
      setShowComplete(false);
    }, 1000);

    PromptForNoCompletionScreen();

    const findCurrentQuest =
      currentQuestNo === parseInt(profile?.currentQuest)
        ? parseInt(profile?.currentQuest)
        : currentQuestNo;
    const QuestContentFiltered = profileData?.Audiogetlanguage.filter(
      (key: any) => key?.textId === findCurrentQuest,
    );
    if (QuestContentFiltered.length > 0) {
      const gameTitleFiltered = QuestContentFiltered.filter(
        (key: any) => key?.fieldName === 'gameScreenTitle',
      );

      const FilteredTitlecontent = gameTitleFiltered[0]?.content
        ? gameTitleFiltered[0]?.content
        : curretQuestOptions?.gameScreenTitle;
      const screenTitleLanguage = FilteredTitlecontent;

      setQuestTitleLanguage(screenTitleLanguage);
    } else {
      setQuestTitleLanguage(curretQuestOptions?.gameScreenTitle);
    }

    findQuestCompletionMessage();
  }, []);

  useEffect(() => {
    if (completionScreenQuestOptions.length > 0) {
      const currentQuestData = completionScreenQuestOptions?.find(
        (quest: any) => quest.gameQuestNo == profile?.currentQuest,
      );
      setCurrentQuestOptions(currentQuestData);
      findQuestCompletionMessage();
    }
  }, [completionScreenQuestOptions]);

  function generateRoundedNumberInRange(
    min: number,
    max: number,
    interval: number,
  ) {
    // Generate a random number within the range
    let randomNum = Math.random() * (max - min) + min;

    // Round the random number to the nearest interval
    let roundedNum = Math.round(randomNum / interval) * interval;

    // Ensure the rounded number is within the range
    return Math.max(min, Math.min(roundedNum, max));
  }

  useEffect(() => {
    const getAndSetMsgDummyScore: () => void = () => {
      const currentQuesTGameData = completionScreenQuestOptions.find(
        (item: any) => item.gameQuestNo === parseInt(currentQuestNo),
      );

      let completionScreenMessage = '';
      let testPlayerScore = 0;
      if (
        (previewStateData?.modifiedField === 'gameIsSetCongratsSingleMessage' &&
          previewStateData?.updatedValue === 'true') ||
        previewStateData?.modifiedField === 'gameCompletedCongratsMessage' ||
        currentQuesTGameData?.gameIsSetCongratsSingleMessage === 'true' ||
        (previewStateData?.modifiedField === 'gameIsSetMinPassScore' &&
          previewStateData?.updatedValue === 'false' &&
          currentQuesTGameData?.gameIsSetDistinctionScore === 'false') ||
        (previewStateData?.modifiedField === 'gameIsSetDistinctionScore' &&
          previewStateData?.updatedValue === 'false' &&
          currentQuesTGameData?.gameIsSetMinPassScore === 'false')
      ) {
        completionScreenMessage =
          currentQuesTGameData?.gameCompletedCongratsMessage;
      } else if (
        currentQuesTGameData?.gameIsSetCongratsScoreWiseMessage === 'true' ||
        (previewStateData?.modifiedField ===
          'gameIsSetCongratsScoreWiseMessage' &&
          previewStateData?.updatedValue === 'true')
      ) {
        // 2. Score wise messages
        if (
          previewStateData?.modifiedField === 'gameIsSetMinPassScore' &&
          previewStateData?.updatedValue === 'true'
        ) {
          completionScreenMessage =
            currentQuesTGameData?.gameaboveMinimumScoreCongratsMessage;
        } else if (
          previewStateData?.modifiedField === 'gameMinimumScoreCongratsMessage'
        ) {
          completionScreenMessage =
            currentQuesTGameData?.gameMinimumScoreCongratsMessage;
        } else if (
          previewStateData?.modifiedField ===
          'gameaboveMinimumScoreCongratsMessage'
        ) {
          completionScreenMessage =
            currentQuesTGameData?.gameaboveMinimumScoreCongratsMessage;
        } else if (
          previewStateData?.modifiedField ===
          'gameAboveDistinctionScoreCongratsMessage'
        ) {
          completionScreenMessage =
            currentQuesTGameData?.gameAboveDistinctionScoreCongratsMessage;
        } else if (previewStateData?.modifiedField === 'gameMinScore') {
          completionScreenMessage =
            currentQuesTGameData?.gameaboveMinimumScoreCongratsMessage;
        } else if (
          previewStateData?.modifiedField === 'gameIsSetMinPassScore' &&
          previewStateData?.updatedValue === 'false'
        ) {
          if (currentQuesTGameData?.gameIsSetDistinctionScore === 'false') {
            completionScreenMessage =
              currentQuesTGameData?.gameCompletedCongratsMessage;
          } else {
            completionScreenMessage =
              currentQuesTGameData?.gameaboveMinimumScoreCongratsMessage;
          }
        } else if (
          previewStateData?.modifiedField === 'gameIsSetDistinctionScore' &&
          previewStateData?.updatedValue === 'false'
        ) {
          completionScreenMessage =
            currentQuesTGameData?.gameaboveMinimumScoreCongratsMessage;
        } else if (previewStateData?.modifiedField === 'gameDistinctionScore') {
          completionScreenMessage =
            currentQuesTGameData?.gameAboveDistinctionScoreCongratsMessage;
        }

        // Score based congrats
        else if (geFinalscorequest < currentQuesTGameData?.gameMinScore) {
          if (currentQuesTGameData?.gameIsSetMinPassScore === 'true') {
            completionScreenMessage =
              currentQuesTGameData?.gameMinimumScoreCongratsMessage;
          } else {
            if (
              geFinalscorequest < currentQuesTGameData?.gameDistinctionScore
            ) {
              completionScreenMessage =
                currentQuesTGameData?.gameaboveMinimumScoreCongratsMessage;
            }
          }
        } else if (geFinalscorequest === currentQuesTGameData?.gameMinScore) {
          completionScreenMessage =
            currentQuesTGameData?.gameaboveMinimumScoreCongratsMessage;
        } else if (
          geFinalscorequest > currentQuesTGameData?.gameDistinctionScore
        ) {
          if (currentQuesTGameData?.gameIsSetDistinctionScore === 'true') {
            completionScreenMessage =
              currentQuesTGameData?.gameAboveDistinctionScoreCongratsMessage;
          } else {
            if (geFinalscorequest > currentQuesTGameData?.gameMinScore) {
              completionScreenMessage =
                currentQuesTGameData?.gameaboveMinimumScoreCongratsMessage;
            }
          }
        } else if (
          geFinalscorequest === currentQuesTGameData?.gameDistinctionScore
        ) {
          if (currentQuesTGameData?.gameIsSetDistinctionScore === 'true') {
            completionScreenMessage =
              currentQuesTGameData?.gameAboveDistinctionScoreCongratsMessage;
          } else {
            completionScreenMessage =
              currentQuesTGameData?.gameaboveMinimumScoreCongratsMessage;
          }
        } else if (
          geFinalscorequest > currentQuesTGameData?.gameMinScore &&
          geFinalscorequest < currentQuesTGameData?.gameDistinctionScore
        ) {
          completionScreenMessage =
            currentQuesTGameData?.gameaboveMinimumScoreCongratsMessage;
        }
      } else {
        if (previewStateData?.modifiedField === 'gameScreenTitle') {
          setQuestTitleLanguage(currentQuesTGameData?.gameScreenTitle);
        }
        testPlayerScore = generateRoundedNumberInRange(
          currentQuesTGameData?.gameMinScore || 0,
          currentQuesTGameData?.gameTotalScore || 200,
          10,
        );
        completionScreenMessage =
          currentQuesTGameData?.gameCompletedCongratsMessage;
      }
      setQuestCompletionMessage(completionScreenMessage);
      setTestScoreTotal(currentQuesTGameData?.gameTotalScore);
    };
    if (
      previewStateData?.currentTab === 5 &&
      previewStateData?.currentSubTab === 0
    ) {
      getAndSetMsgDummyScore();
    }
  }, [previewStateData, curretQuestOptions, currentQuestNo]);

  const getcompletionquest = currentQuestNo - 1;

  /** This useEffect Only hanldes the total within the quest total */
  useEffect(() => {
    let questTotalScore = Object.entries(
      profile?.playerGrandTotal?.questScores,
    ).reduce((totalScore: any, [key, value]: [any, any]) => {
      if (key == profile.currentQuest) {
        return totalScore + value;
      }
      return totalScore;
    }, 0);

    let scoresfinal: any = [];
    const questStatus = questState[profile?.currentQuest];

    const scores = profile?.score;

    const sums: any = {};
    scores?.forEach((score: any) => {
      const quest = score.quest;
      if (!sums[quest]) {
        sums[quest] = 0;
      }
      sums[quest] += score.score;
    });
    const Replayscores =
      profile?.replayScore.length > 0 ? profile?.replayScore : null;

    const Replaysums: { [key: number]: number } = {};
    Replayscores?.forEach((score: any) => {
      const quest = score.quest;
      if (!Replaysums[quest]) {
        Replaysums[quest] = 0;
      }

      Replaysums[quest] += score.score;
    });
    if (questStatus === 'completed') {
      // If the quest is completed, compare the scores
      if (
        sums[profile?.currentQuest] !== undefined &&
        Replaysums[profile?.currentQuest] !== undefined
      ) {
        scoresfinal =
          sums[profile?.currentQuest] > Replaysums[profile?.currentQuest]
            ? profile.score
            : profile.replayScore;
      } else {
        if (sums[profile?.currentQuest] !== undefined) {
          scoresfinal = profile?.score;
        } else if (Replaysums[profile?.currentQuest] !== undefined) {
          scoresfinal = profile?.replayScore;
        }
      }
    } else if (questStatus === 'Started') {
      // If the quest is started, consider the score
      scoresfinal = profile?.score.length > 0 ? profile.score : 0; //null or scoresfinal or replayScore
    } else if (questStatus === 'replayallowed') {
      if (Replaysums[profile?.currentQuest] !== undefined) {
        scoresfinal = profile?.replayScore;
      } else if (sums[profile?.currentQuest] !== undefined) {
        scoresfinal = profile?.score;
      }
    } else {
      if (
        sums[profile?.currentQuest] !== undefined &&
        Replaysums[profile?.currentQuest] !== undefined
      ) {
        scoresfinal =
          sums[profile?.currentQuest] > Replaysums[profile?.currentQuest]
            ? profile.score
            : profile.replayScore;
      } else {
        if (sums[profile?.currentQuest] !== undefined) {
          scoresfinal = profile?.score;
        } else if (Replaysums[profile?.currentQuest] !== undefined) {
          scoresfinal = profile?.replayScore;
        }
      }
    }
    const sumsFinal: any = {};
    if (scoresfinal && scoresfinal?.length > 0) {
      scoresfinal.forEach((score: any) => {
        const quest = score.quest;
        if (!sumsFinal[quest]) {
          sumsFinal[quest] = 0;
        }
        sumsFinal[quest] += score.score;
      });
      const getFinalscores = Object.entries(sumsFinal).map(
        ([quest, score]) => ({
          quest,
          score,
        }),
      );
      const getscores = getFinalscores.find(
        (row: any) => parseInt(row.quest) === parseInt(profile?.currentQuest),
      );
      const finalscore = getscores?.score;
      questTotalScore = questTotalScore <= 0 ? finalscore : questTotalScore;
    } else {
      const getcompletionquest = currentQuestNo - 1;

      let scorenotdefined = 0;
    }
  }, [profile.score]);

  const currentQuestScore = useMemo(() => {
    if (questScores && questScores[profile?.currentQuest]) {
      return questScores[profile?.currentQuest];
    } else {
      let currentScores: any[];
      let totalFlowScore: number = 0;
      const questStatus = questState[profile?.currentQuest];
      const scores = profile?.score;
      const sums: any = {};
      scores?.forEach((score: any) => {
        const quest = score.quest;
        if (!sums[quest]) {
          sums[quest] = 0;
        }
        sums[quest] += score.score;
      });
      const Replayscores =
        profile?.replayScore.length > 0 ? profile?.replayScore : null;
      const Replaysums: { [key: number]: number } = {};
      Replayscores?.forEach((score: any) => {
        const quest = score.quest;
        if (!Replaysums[quest]) {
          Replaysums[quest] = 0;
        }

        Replaysums[quest] += score.score;
      });
      if (questStatus === 'completed') {
        // If the quest is completed, compare the scores
        if (
          sums[profile?.currentQuest] !== undefined &&
          Replaysums[profile?.currentQuest] !== undefined
        ) {
          currentScores =
            sums[profile?.currentQuest] > Replaysums[profile?.currentQuest]
              ? profile.score
              : profile.replayScore;
        } else {
          if (sums[profile?.currentQuest] !== undefined) {
            currentScores = profile?.score;
          } else if (Replaysums[profile?.currentQuest] !== undefined) {
            currentScores = profile?.replayScore;
          }
        }
      } else if (questStatus === 'Started') {
        // If the quest is started, consider the score
        currentScores = profile?.score.length > 0 ? profile.score : null; //null or currentScores or replayScore
      } else {
        if (
          sums[profile?.currentQuest] !== undefined &&
          Replaysums[profile?.currentQuest] !== undefined
        ) {
          currentScores =
            sums[profile?.currentQuest] > Replaysums[profile?.currentQuest]
              ? profile.score
              : profile.replayScore;
        } else {
          if (sums[profile?.currentQuest] !== undefined) {
            currentScores = profile?.score;
          } else if (Replaysums[profile?.currentQuest] !== undefined) {
            currentScores = profile?.replayScore;
          }
        }
      }

      const currentQuestseqId = Array.isArray(currentScores)
        ? currentScores.map((item) => item.seqId)
        : [];
      if (Array.isArray(currentScores) && currentScores.length > 0) {
        const result = currentQuestseqId.map((seqId) => {
          const QuestNo = seqId.split('.')[0];
          if (QuestNo == profile?.currentQuest) {
            const filteredOptions = questOptions?.filter(
              (option: any) => option.qpSequence == seqId,
            );
            const qpScoresOption = filteredOptions.map((option: any) =>
              parseInt(option.qpScore),
            );
            qpScoresOption.sort((a: any, b: any) => b - a);
            totalFlowScore += qpScoresOption[0];
          }
        });
      }
      return totalFlowScore > 0
        ? totalFlowScore
        : curretQuestOptions?.gameTotalScore ?? 0;
    }
  }, [questScores, profile?.currentQuest, gameInfoTotalScore]);

  const previousNavigation = () => {
    // currentQuestNo
    if (Gameid) {
      if (getPrevLogDatas?.nevigatedSeq[String(currentQuestNo)]) {
        const lengthOfNavigation =
          getPrevLogDatas?.nevigatedSeq[String(currentQuestNo)]?.length;
        const lastSeq =
          lengthOfNavigation > 0
            ? getPrevLogDatas?.nevigatedSeq[String(currentQuestNo)][
                lengthOfNavigation - 1
              ]
            : null;
        if (lastSeq !== null) {
          let SetLastSeqData: any = {};
          for (const key in demoBlocks[currentQuestNo]) {
            const data = demoBlocks[currentQuestNo][key];
            if (data.blockPrimarySequence === lastSeq) {
              SetLastSeqData = data;
              break;
            }
          }
          if (Object.entries(SetLastSeqData).length > 0) {
            setData(SetLastSeqData);
            setType(SetLastSeqData?.blockChoosen);
            if (SetLastSeqData?.blockChoosen === 'Interaction') {
              profile.score = profile?.score.filter(
                (item: any) =>
                  item.seqId !== SetLastSeqData?.blockPrimarySequence,
              );
              profile.replayScore = profile?.replayScore.filter(
                (item: any) =>
                  item.seqId !== SetLastSeqData?.blockPrimarySequence,
              );
              const updatedFeedbackList = feedbackList?.filter(
                (item: any) =>
                  item.Seq !== SetLastSeqData?.blockPrimarySequence,
              );
              setFeedbackList(updatedFeedbackList);
              const optionsFiltered = [];
              const primarySequence = lastSeq;
              const gameInfoquest = gameInfo.questOptions;
              for (const option of gameInfoquest) {
                if (profileData?.Audiogetlanguage.length > 0) {
                  if (option?.qpSequence === primarySequence) {
                    const profilesetlan = profileData?.Audiogetlanguage.find(
                      (key: any) => key?.textId === option.qpOptionId,
                    );

                    if (profilesetlan) {
                      const languagecont = {
                        ...option,
                        qpOptionText: profilesetlan.content,
                      };
                      optionsFiltered.push(languagecont);
                    } else {
                      optionsFiltered.push(option);
                    }
                  }
                } else {
                  if (option?.qpSequence === primarySequence) {
                    optionsFiltered.push(option);
                  }
                }
              }
              const gameinfodata = gameInfo?.gameData?.gameShuffle;
              if (gameinfodata === 'true') {
                for (let i = optionsFiltered.length - 1; i > 0; i--) {
                  const j = Math.floor(Math.random() * (i + 1));
                  [optionsFiltered[i], optionsFiltered[j]] = [
                    optionsFiltered[j],
                    optionsFiltered[i],
                  ]; // Swap elements at indices i and j
                }
              }
              setOptions(optionsFiltered);
            }
            setCurrentScreenId(2);
            return false;
          } else {
            for (const key in gameInfo?.blocks[currentQuestNo]) {
              const data = gameInfo?.blocks[currentQuestNo][key];
              if (data.blockPrimarySequence === lastSeq) {
                SetLastSeqData = data;
                break;
              }
            }
            if (Object.entries(SetLastSeqData).length > 0) {
              setData(SetLastSeqData);
              setType(SetLastSeqData?.blockChoosen);
              if (SetLastSeqData?.blockChoosen === 'Interaction') {
                profile.score = profile?.score.filter(
                  (item: any) =>
                    item.seqId !== SetLastSeqData?.blockPrimarySequence,
                );
                profile.replayScore = profile?.replayScore.filter(
                  (item: any) =>
                    item.seqId !== SetLastSeqData?.blockPrimarySequence,
                );
                const updatedFeedbackList = feedbackList?.filter(
                  (item: any) =>
                    item.Seq !== SetLastSeqData?.blockPrimarySequence,
                );
                setFeedbackList(updatedFeedbackList);
                const optionsFiltered = [];
                const primarySequence = lastSeq;
                const gameInfoquest = gameInfo.questOptions;
                for (const option of gameInfoquest) {
                  if (profileData?.Audiogetlanguage.length > 0) {
                    if (option?.qpSequence === primarySequence) {
                      const profilesetlan = profileData?.Audiogetlanguage.find(
                        (key: any) => key?.textId === option.qpOptionId,
                      );

                      if (profilesetlan) {
                        const languagecont = {
                          ...option,
                          qpOptionText: profilesetlan.content,
                        };
                        optionsFiltered.push(languagecont);
                      } else {
                        optionsFiltered.push(option);
                      }
                    }
                  } else {
                    if (option?.qpSequence === primarySequence) {
                      optionsFiltered.push(option);
                    }
                  }
                }
                const gameinfodata = gameInfo?.gameData?.gameShuffle;
                if (gameinfodata === 'true') {
                  for (let i = optionsFiltered.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [optionsFiltered[i], optionsFiltered[j]] = [
                      optionsFiltered[j],
                      optionsFiltered[i],
                    ]; // Swap elements at indices i and j
                  }
                }
                setOptions(optionsFiltered);
              }
              setCurrentScreenId(2);
              return false;
            } else {
              setCurrentScreenId(13);
              return false;
            }
          }
        } else {
          setCurrentScreenId(13);
          return false;
        }
      } else {
        setCurrentScreenId(13);
        return false;
      }
    } else {
      const valuesArray =
        gameInfo?.blocks && gameInfo?.blocks[currentQuestNo]
          ? Object.values(gameInfo?.blocks[currentQuestNo])
          : null;
      const lastItem: any =
        valuesArray !== null ? valuesArray[valuesArray.length - 1] : null;
      if (lastItem !== null) {
        setData(lastItem);
        setType(lastItem?.blockChoosen);
        if (lastItem?.blockChoosen === 'Interaction') {
          profile.score = profile?.score.filter(
            (item: any) => item.seqId !== lastItem?.blockPrimarySequence,
          );
          profile.replayScore = profile?.replayScore.filter(
            (item: any) => item.seqId !== lastItem?.blockPrimarySequence,
          );
          const updatedFeedbackList = feedbackList?.filter(
            (item: any) => item.Seq !== lastItem?.blockPrimarySequence,
          );
          setFeedbackList(updatedFeedbackList);
          const optionsFiltered = [];
          const primarySequence = lastItem?.blockPrimarySequence;
          const gameInfoquest = gameInfo.questOptions;
          for (const option of gameInfoquest) {
            if (profileData?.Audiogetlanguage.length > 0) {
              if (option?.qpSequence === primarySequence) {
                const profilesetlan = profileData?.Audiogetlanguage.find(
                  (key: any) => key?.textId === option.qpOptionId,
                );

                if (profilesetlan) {
                  const languagecont = {
                    ...option,
                    qpOptionText: profilesetlan.content,
                  };
                  optionsFiltered.push(languagecont);
                } else {
                  optionsFiltered.push(option);
                }
              }
            } else {
              if (option?.qpSequence === primarySequence) {
                optionsFiltered.push(option);
              }
            }
          }
          const gameinfodata = gameInfo?.gameData?.gameShuffle;
          if (gameinfodata === 'true') {
            for (let i = optionsFiltered.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [optionsFiltered[i], optionsFiltered[j]] = [
                optionsFiltered[j],
                optionsFiltered[i],
              ]; // Swap elements at indices i and j
            }
          }
          setOptions(optionsFiltered);
        }
        setCurrentScreenId(2);
        return false;
      } else {
        setCurrentScreenId(13);
        return false;
      }
    }
  };
  useEffect(() => {
    const currentQuest = profile?.currentQuest;
    gameInfo?.gameQuest.map((item: any, index: number) => {
      const questNoAsString = item.gameQuestNo.toString();

      const nextLevel = parseInt(profile?.currentQuest) + 1 || null;

      if (profile?.completedLevels?.includes(questNoAsString)) {
        const scores = profile?.score;
        if (scores !== undefined) {
          const sums: any = {};
          scores.forEach((score: any) => {
            const quest = score.quest;
            if (!sums[quest]) {
              sums[quest] = 0;
            }
            sums[quest] += score.score;
          });
          const getFinalscores = Object.entries(sums).map(([quest, score]) => ({
            quest,
            score,
          }));
          const getscores = getFinalscores.find(
            (row: any) => row.quest == item.gameQuestNo,
          );
          const finalscore = getscores?.score ?? 0;

          if (formData?.gameDisableOptionalReplays === 'false') {
            // //start
            if (item?.gameIsSetMinPassScore === 'true') {
              const getminpassscore = item?.gameMinScore;

              if (
                finalscore >= getminpassscore &&
                finalscore < item?.gameTotalScore &&
                profile.compQuest.includes(questNoAsString)
              ) {
                setQuestState((prevquestdataList: any) => ({
                  ...prevquestdataList,
                  [item.gameQuestNo]: 'replayallowed',
                }));
              } else {
                if (
                  finalscore !== undefined &&
                  profile.compQuest.includes(questNoAsString)
                ) {
                  const status =
                    gameInfo?.gameData?.gameDisableOptionalReplays === 'false'
                      ? 'replayallowed'
                      : 'completed';

                  setQuestState((prevquestdataList: any) => ({
                    ...prevquestdataList,
                    [item.gameQuestNo]: 'replayallowed',
                  }));
                } else {
                  setQuestState((prevquestdataList: any) => ({
                    ...prevquestdataList,
                    [item.gameQuestNo]: 'Started',
                  }));
                }
              }
            } else {
              if (
                finalscore !== undefined &&
                profile.compQuest.includes(questNoAsString)
              ) {
                setQuestState((prevquestdataList: any) => ({
                  ...prevquestdataList,
                  [item.gameQuestNo]: 'replayallowed',
                }));
              } else {
                if (
                  item.gameIsSetMinPassScore === 'false' &&
                  profile.compQuest.includes(questNoAsString)
                ) {
                  setQuestState((prevquestdataList: any) => ({
                    ...prevquestdataList,
                    [item.gameQuestNo]: 'completed',
                  }));
                } else {
                  setQuestState((prevquestdataList: any) => ({
                    ...prevquestdataList,
                    [item.gameQuestNo]: 'Started',
                  }));
                }
              }
            }
            //   //end
          } else {
            //Mandatory replay, even though formData?.gameDisableOptionalReplays is false, could allow when the min scroe is not set, or if has min score, then score less than minscore, it could navaigate to replay point

            //start
            if (
              finalscore !== undefined &&
              profile.compQuest.includes(questNoAsString)
            ) {
              setQuestState((prevquestdataList: any) => ({
                ...prevquestdataList,
                [item.gameQuestNo]: 'completed',
              }));
            } else if (
              item.gameIsSetMinPassScore === 'false' &&
              profile.compQuest.includes(questNoAsString)
            ) {
              setQuestState((prevquestdataList: any) => ({
                ...prevquestdataList,
                [item.gameQuestNo]: 'completed',
              }));
            } else {
              //end

              setQuestState((prevquestdataList: any) => ({
                ...prevquestdataList,
                [item.gameQuestNo]: 'Started',
              }));
            }
          }
        }
      } else {
        setQuestState((prevquestdataList: any) => ({
          ...prevquestdataList,
          [item.gameQuestNo]: 'locked',
        }));
      }
    });
  }, [profile?.compleLevel]);

  return (
    <>
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Box className="comple-screen">
          <Img src={preloadedAssets.Screen1} className="bg-img" />
          <Box className="title">
            <Text fontFamily={'AtlantisText'} textAlign={'center'}>
              {QuestTitleLanguage}
            </Text>
          </Box>
          <Box className="content-box">
            <Box className="congratulations">
              <Box className="content" mt="0px">
                {quetCompletionMessage}
              </Box>
            </Box>
            <Box className="rewards-img-box">
              <Img className="rewards-arrow-img" src={preloadedAssets.rew} />
            </Box>
            <Box className="points-box">
              <Box className="box-1">
                <Img src={preloadedAssets.back} className="box-1_img" />
                <Text className="points-text" fontFamily={'content'}>
                  points
                </Text>
                <Box className="inside-box-1">
                  <Img
                    src={preloadedAssets.point}
                    className="inside-box-1_img"
                  />
                  <Text className="inside-points-text" fontFamily={'content'}>
                    {`${geFinalscorequest ? geFinalscorequest : 0 || 0}/`}
                    {curretQuestOptions?.gameTotalScore}
                  </Text>
                </Box>
              </Box>

              {curretQuestOptions?.gameIsSetBadge === 'true' && (
                <Box className="box-2 dfg">
                  <Img src={preloadedAssets.back} className="box-2_img" />
                  <Text className="points-text" fontFamily={'content'}>
                    {curretQuestOptions?.gameBadge &&
                    curretQuestOptions?.gameBadge !== ''
                      ? curretQuestOptions?.gameBadgeName
                      : ''}
                  </Text>
                  {curretQuestOptions?.gameBadge &&
                  curretQuestOptions?.gameBadge !== '' &&
                  curretQuestOptions?.gameIsSetCriteriaForBadge === 'true' ? (
                    curretQuestOptions?.gameAwardBadgeScore <=
                    geFinalscorequest ? (
                      <Img
                        className="inside-img"
                        src={
                          preloadedAssets[
                            `Quest_${
                              currentQuestNo === profile?.currentQuest
                                ? profile?.currentQuest
                                : currentQuestNo
                            }`
                          ]
                        }
                      />
                    ) : (
                      <span className="missed-reward">
                        You missed the reward!
                      </span>
                    )
                  ) : (
                    <Img
                      className="inside-img"
                      src={
                        preloadedAssets[
                          `Quest_${
                            currentQuestNo === profile?.currentQuest
                              ? profile?.currentQuest
                              : currentQuestNo
                          }`
                        ]
                      }
                    />
                  )}{' '}
                </Box>
              )}
            </Box>
          </Box>
          <Box className="next-btn">
            {gameInfo.gameData?.gameDisableOptionalReplays === 'false' ? (
              <Img
                src={preloadedAssets.left}
                className={'interaction_button'}
                onClick={() => previousNavigation()}
              />
            ) : (
              <Img />
            )}

            <Img src={preloadedAssets.right} onClick={() => getData(data)} />
          </Box>
        </Box>
      </motion.div>
    </>
  );
};
export default Completion;
